
export default [
  {
    path: '/home',          //首页
    name: 'home',          //首页
    component: (resolve) => require(['@/views/home/home'], resolve),
    meta: {
      title: 'global.home_page',
      code: 'system',
    },
    redirect: '/statistic_analysis',
    children: [
      {
        path: 'statistic_analysis',           // 数据大屏
        name: 'statistic_analysis',           // 数据大屏
        component: resolve => require(['@/views/statistic_analysis/statistic_analysis2.vue'], resolve),
        meta: {
          title: 'global.statistic_analysis',
          isMenu: true,
          code: "statistic"
        }
      },
      {
        path: 'grading_management',        //分级管理
        name: 'grading_management',        //分级管理
        component: resolve => require(['@/views/grading_management/grading_management'], resolve),
        meta: {
          title: 'global.grading_management',
          isMenu: true,
          code: "grading"
        }
      },
      {
        path: 'grading_criteria',        //分级标准
        name: 'grading_criteria',        //分级标准
        component: resolve => require(['@/views/grading_criteria/grading_criteria'], resolve),
        meta: {
          title: 'global.grading_criteria',
          isMenu: true,
          code: 'grading',
        }
      },
      {
        path: 'grading_gmanage',        // 标准制定
        name: 'grading_gmanage',        // 标准制定
        component: resolve => require(['@/views/grading_criteria/grading_gmanage'], resolve),
        meta: {
          title: 'global.grading_gmanage',
          isMenu: false,
          code: 'grading',
        }
      },
      {
        path: 'patient_management',           // 患者管理
        name: 'patient_management',           // 患者管理
        component: resolve => require(['@/views/patient_management/patient_management'], resolve),
        meta: {
          title: 'global.patient_management',
          isMenu: true,
          code: "patient"
        },
      },
      {
        path: 'personnel_details',            //患者人员详情
        name: 'personnel_details',            //患者人员详情
        component: resolve => require(['@/views/patient_management/modules/personnel_details'], resolve),
        meta: {
          title: 'global.personnel_details',
          code: 'patient',
        }

      },
      {
        path: 'accompanying_management',           // 人员（护工）管理
        name: 'accompanying_management',           // 人员（护工）管理
        component: resolve => require(['@/views/accompanying_management/accompanying_management.vue'], resolve),
        meta: {
          title: 'global.accompanying_management',
          isMenu: true,
          code: "caregiver"
        },
      },
      {
        path: 'accompanying_type_management',           // 人员（护工）管理
        name: 'accompanying_type_management',           // 人员（护工）管理
        component: resolve => require(['@/views/accompanying_type_management/accompanying_type_management.vue'], resolve),
        meta: {
          title: 'global.accompanying_type_management',
          isMenu: true,
          code: "caregiver"
        },
      },
      {
        path: 'caregiver_post_management',        // 护理员分类
        name: 'caregiver_post_management',        // 护理员分类
        component: resolve => require(['@/views/caregiver_post_management/caregiver_post_management.vue'], resolve),
        meta: {
          title: 'global.caregiver_post_management',
          isMenu: true,
          code: 'caregiver',
        }
      },
      {
        path: 'accompanying_details',            // 人员（护工）详情
        name: 'accompanying_details',            // 人员（护工）详情
        component: resolve => require(['@/views/accompanying_management/modules/accompanying_details.vue'], resolve),
        meta: {
          title: 'global.accompanying_details',
          code: "caregiver"
        }

      },
      {
        path: 'accompanying_history',            // 人员（护工）照护记录
        name: 'accompanying_history',            // 人员（护工）照护记录
        component: resolve => require(['@/views/accompanying_management/modules/accompanying_history.vue'], resolve),
        meta: {
          title: 'global.accompanying_history',
          code: "caregiver"
        }

      },
      {
        path: 'orders_management',           // 订单管理
        name: 'orders_management',           // 订单管理
        component: resolve => require(['@/views/orders_management/orders_management'], resolve),
        meta: {
          title: 'global.orders_management',
          isMenu: true,
          code: "orders"
        },
      },
      {
        path: 'base_order_management',
        name: 'base_order_management',
        component: resolve => require(['@/views/base_order_management/base_order_management'], resolve),
        meta: {
          title: '基础订单',
          isMenu: true,
          code: "base_order"
        },
      },
      {
        path: 'bill_management',
        name: 'bill_management',
        component: resolve => require(['@/views/bill_management/bill_management'], resolve),
        meta: {
          title: '账单管理',
          isMenu: true,
          code: "bill"
        },
      },
      {
        path: 'appointment_management' ,           // 预约管理
        name: 'appointment_management',           // 预约管理
        component: resolve => require(['@/views/appointment_management/appointment_management'], resolve),
        meta: {
          title: 'global.appointment_management',
          isMenu: true,
          code: "appointment"
        },
      },
      {
        path: 'appointment_details',           // 预约详情
        name: 'appointment_details',           // 预约详情
        component: resolve => require(['@/views/appointment_management/modules/appointment_details'], resolve),
        meta: {
          title: 'global.appointment_details',
          isMenu: false,
          code: "appointment"
        },
      },
      {
        path: 'contract_management',           // 合同管理
        name: 'contract_management',           // 合同管理
        component: resolve => require(['@/views/contract_management/contract_management'], resolve),
        meta: {
          title: 'global.contract_management',
          isMenu: true,
          code: "contract"
        },
      },
      {
        path: 'order_details',           // 订单详情
        name: 'order_details',           // 订单详情
        component: resolve => require(['@/views/orders_management/modules/order_details'], resolve),
        meta: {
          title: 'global.order_details',
          code: "orders"
        },
      },
      {
        path: 'accompaniment_order',           // 增加陪护人员
        name: 'accompaniment_order',           // 增加陪护人员
        component: resolve => require(['@/views/orders_management/modules/accompaniment_order.vue'], resolve),
        meta: {
          title: 'global.accompaniment_order',
          code: "patient"
        },
      },
      {
        path: 'complain_management',        // 投诉管理
        name: 'complain_management',        // 投诉管理
        component: resolve => require(['@/views/complain_management/complain_management'], resolve),
        meta: {
          title: 'global.complain_management',
          isMenu: true
        }
      },
      {
        path: 'company_management',        // 公司管理
        name: 'company_management',        // 公司管理
        component: resolve => require(['@/views/company_management/company_management'], resolve),
        meta: {
          title: 'global.company_management',
          isMenu: true,
          code: 'company',
        }
      },
      {
        path: 'company_reports',        // 分析报表
        name: 'company_reports',        // 分析报表
        component: resolve => require(['@/views/analyse_reports/analyse_reports'], resolve),
        meta: {
          title: 'global.company_reports',
          isMenu: true
          // code: 'mgr',
        }
      },
      {
        path: 'class_type',        // 班种管理
        name: 'class_type',        // 班种管理
        component: resolve => require(['@/views/class_type_management/class_type_management'], resolve),
        meta: {
          title: 'global.class_type_management',
          isMenu: true,
          code: 'class_type',
        }
      },
      {
        path: 'class_group',        // 班组管理
        name: 'class_group',        // 班组管理
        component: resolve => require(['@/views/class_group_management/class_group_management'], resolve),
        meta: {
          title: 'global.class_group_management',
          isMenu: true,
          code: 'class_group',
        }
      },
      {
        path: 'class_scheduling',        // 人员排班
        name: 'class_scheduling',        // 人员排班
        component: resolve => require(['@/views/class_scheduling_management/class_scheduling_management'], resolve),
        meta: {
          title: 'global.class_scheduling_management',
          isMenu: true,
          code: 'class_scheduling',
        }
      },
      // {
      //   path: 'system_reports',        // 系统报表（按公司统计）
      //   component: resolve => require(['@/views/system_reports/system_reports'], resolve),
      //   meta: {
      //     title: 'global.system_reports',
      //     isMenu: true
      //     // code: 'mgr',
      //   }
      // },
      {
        path: 'scale_management',        // 调查表模板
        name: 'scale_management',        // 调查表模板
        component: resolve => require(['@/views/scale_management/scale_management'], resolve),
        meta: {
          title: 'global.scale_management',
          isMenu: true,
          code: 'scale',
        }
      },
      {
        path: 'certificate_management',        // 证书管理
        name: 'certificate_management',        // 证书管理
        component: resolve => require(['@/views/certificate_management/certificate_management'], resolve),
        meta: {
          title: 'global.certificate_management',
          isMenu: true,
          code: 'certificate',
        }
      },
      {
        path: 'certificate_type_management',        // 证书类型管理
        name: 'certificate_type_management',        // 证书类型管理
        component: resolve => require(['@/views/certificate_type_management/certificate_type_management'], resolve),
        meta: {
          title: 'global.certificate_type_management',
          isMenu: true,
          code: 'certificate_type',
        }
      },
      {
        path: 'care_level_management',        // 护理级别
        name: 'care_level_management',        // 护理级别
        component: resolve => require(['@/views/care_level_management/care_level_management'], resolve),
        meta: {
          title: 'global.care_level_management',
          isMenu: true,
          code: 'care_level',
        }
      },
      {
        path: 'care_level_detail_management',        // 护理级别
        name: 'care_level_detail_management',        // 护理级别
        component: resolve => require(['@/views/care_level_detail_management/care_level_detail_management'], resolve),
        meta: {
          title: 'global.care_level_detail_management',
          isMenu: true,
          code: 'care_level',
        }
      },
      {
        path: 'care_record_management',        // 护理级别
        name: 'care_record_management',        // 护理级别
        component: resolve => require(['@/views/care_record_management/care_record_management'], resolve),
        meta: {
          title: 'global.care_record_management',
          isMenu: true,
          code: 'care_level_price',
        }
      },
            {
        path: 'care_level_price_management',        // 护理级别
        name: 'care_level_price_management',        // 护理级别
        component: resolve => require(['@/views/care_level_price_management/care_level_price_management'], resolve),
        meta: {
          title: 'global.care_level_price_management',
          isMenu: true,
          code: 'care_level_price',
        }
      },
      {
        path: 'workers_discount_management',        // 职工折扣管理
        name: 'workers_discount_management',        // 职工折扣管理
        component: resolve => require(['@/views/workers_discount_management/workers_discount_management'], resolve),
        meta: {
          title: 'global.workers_discount_management',
          isMenu: true,
          code: 'care_level_price',
        }
      },
      {
        path: 'base_service_price_management',
        name: 'base_service_price_management',
        component: resolve => require(['@/views/base_service_price_management/base_service_price_management'], resolve),
        meta: {
          title: '基础收费',
          isMenu: true,
          code: 'dept',
        }
      },
      {
        path: 'care_level_type_management' ,        // 护理模式
        name: 'care_level_type_management',        // 护理模式
        component: resolve => require(['@/views/care_level_type_management/care_level_type_management'], resolve),
        meta: {
          title: 'global.care_level_type_management',
          isMenu: true,
          code: 'care_level_price',
        }
      },
      {
        path: 'care_star_price_management',        // 护理级别
        name: 'care_star_price_management',        // 护理级别
        component: resolve => require(['@/views/care_level_price_management/care_star_price_management'], resolve),
        meta: {
          title: 'global.care_star_price_management',
          isMenu: false
          // code: 'mgr',
        }
      },
      {
        path: 'user_management',        //用户管理
        name: 'user_management',        //用户管理
        component: resolve => require(['@/views/user_management/user_management'], resolve),
        meta: {
          title: 'global.users',
          isMenu: true,
          code: 'mgr',
        }
      },
      {
        path: 'role_management',         //角色管理
        name: 'role_management',         //角色管理
        component: resolve => require(['@/views/role_management/role_management'], resolve),
        meta: {
          title: 'global.roles',
          isMenu: true,
          code: 'role',
        }
      },
      {
        path: 'dept_management',         //部门管理
        name: 'dept_management',         //部门管理
        component: resolve => require(['@/views/dept_management/dept_management'], resolve),
        meta: {
          title: 'global.depts',
          isMenu: true,
          code: 'dept',
        }
      },
      {
        path: 'building_management',         //楼栋管理
        name: 'building_management',         //楼栋管理
        component: resolve => require(['@/views/building_management/building_management'], resolve),
        meta: {
          title: 'global.building',
          isMenu: true
        }
      },
      {
        path: 'personnel_management',         //楼栋管理
        name: 'personnel_management',         //楼栋管理
        component: resolve => require(['@/views/personnel_management/personnel_management'], resolve),
        meta: {
          title: 'global.personnel_management',
          isMenu: true
        }
      },
      {
        path: 'bed_management',         //楼栋管理
        name: 'bed_management',         //楼栋管理
        component: resolve => require(['@/views/bed_management/bed_management'], resolve),
        meta: {
          title: 'global.bed_management',
          isMenu: true
        }
      },
      {
        path: 'dict_management',            //字典管理
        name: 'dict_management',            //字典管理
        component: resolve => require(['@/views/dict_management/dict_management'], resolve),
        meta: {
          title: 'global.dict_type',
          isMenu: true,
          code: 'dict'

        }
      },
      {
        path: 'dict_detail_management',            //字典详情管理
        name: 'dict_detail_management',            //字典详情管理
        component: resolve => require(['@/views/dict_management/dict_detail_management'], resolve),
        meta: {
          title: "字典详情",
          isMenu: false,
          code: 'dict',
        }
      },
      {
        path: 'menu_management',            //菜单管理
        name: 'menu_management',            //菜单管理
        component: resolve => require(['@/views/menu_management/menu_management'], resolve),
        meta: {
          title: 'global.menus',
          isMenu: true,
          code: 'menu',
        }
      },
      {
        path: '/user_management',
        name: 'user_management',
        component: resolve => require(['@/views/user_management/user_management'], resolve),
        meta: {
          title: 'global.users',
          isMenu: true,
          code: 'mgr',
        }
      },
      {
        path: 'banner_management',        //  小程序轮播图管理
        name: 'banner_management',        //  小程序轮播图管理
        component: resolve => require(['@/views/wechat_management/banner_management'], resolve),
        meta: {
          title: 'global.banner_management',
          isMenu: true,
          code: "wechat"
        }
      },
      {
        path: 'news_management',        //  小程序资讯管理
        name: 'news_management',        //  小程序资讯管理
        component: resolve => require(['@/views/wechat_management/news_management'], resolve),
        meta: {
          title: 'global.news_management',
          isMenu: true,
          code: "wechat"
        }
      },
      {
        path: 'login_log',                 //登录日志
        name: 'login_log',                 //登录日志
        component: resolve => require(['@/views/login_log/login_log'], resolve),
        meta: {
          title: 'global.login_log',
          code: 'loginLog',
        }
      },
      {
        path: 'business_log',             //业务日志
        name: 'business_log',             //业务日志
        component: resolve => require(['@/views/business_log/business_log'], resolve),
        meta: {
          title: 'global.business_log',
          code: 'log',
        }
      },
    ]
  },
  {
    path: '/statistic_analysis_fullscreen',           // 数据大屏全屏
    name: '/statistic_analysis_fullscreen',           // 数据大屏全屏
    component: resolve => require(['@/views/statistic_analysis/statistic_analysis'], resolve),
    meta: {
      title: 'global.statistic_analysis',
      code: "system"
    }
  },
  {
    path: '/statistic_analysis_fullscreen2',           // 数据大屏全屏
    name: '/statistic_analysis_fullscreen2',           // 数据大屏全屏
    component: resolve => require(['@/views/statistic_analysis/statistic_analysis2'], resolve),
    meta: {
      title: 'global.statistic_analysis',
      code: "system"
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/module/system_setting.js